import * as React from "react"
import { slugify } from "../../custom_utils/helpers"
import { getCurrentFilterQuery } from "./filters"
import { Link } from "./library/link"
import { ActivitySummaryWithFirstDateProps } from "./tipped_activities_block"
import { TippedTeaserContent } from "./tipped_teaser"


export const TippedActivitySummary = (p: ActivitySummaryWithFirstDateProps & { row_count: number }): JSX.Element => (
  p.title == "loading" ? null : (
    <li className={`teaser teaser--image tip-activity ${p.row_count == 4 ? 'col-xs-12 col-sm-6 col-md-4 col-ld-3' : 'col-xs-12 col-sm-6 col-md-4'}`}>
      <Link
        key={p.route}
        url={`${p.route}${getCurrentFilterQuery()}`}
        className="teaser__link"
        handle={() => p.onClick && p.onClick()}
        aria-labelledby={`a11y-teaser-title-${slugify(p.title)}`}
      >
        <TippedTeaserContent
          headingLevel={p.headingLevel}
          title={p.title}
          isTip={p.isTip}
          imageUrl={p.imageUrl}
          imageAlt={p.imageAlt}
          intro={p.subtitle}
          location={p.location == "multiple" ? "Meerdere locaties" : p.location}
          date={p.date}
        />
      </Link>
    </li>
  )
)